import React, { useEffect, useRef } from "react";
import { Messages } from "../../types";

export function HeldRunsBannerWrapper() {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    window.onmessage = function (e: any) {
      if (e.data.type === Messages.sizeChange) {
        if (iframeRef.current) {
          iframeRef.current.height = e.data.height;
        }
      }
    };

    return () => {
      window.onmessage = null;
    };
  }, []);

  // We want `src` to only be calculated one time to prevent the iframe React component
  // from re-rendering when the route changes. We want to tell the iframe directly to change
  // route instead of letting it naturally re-render with a new src
  const src = useRef(
    `/embed/reporting/held-runs-banner?${window.location.search.substring(1)}`
  );

  return (
    <iframe
      height={0}
      key={src.current}
      ref={iframeRef}
      src={src.current}
      // There must be a negative margin on the iframe or part of it gets cut off
      // We put overflow hidden on the iframe so we don't see a flash of a scroll bar
      style={{ border: "none", marginBottom: "-20px", overflow: "hidden" }}
      title="Held Runs Banner Embed"
      width="100%"
      scrolling="no"
    />
  );
}
